import { P, Predicate } from "breadcommon";

export interface TransactionColumnFilterDisplayReviewedProps {
  predicate: Predicate;
}

export function TransactionColumnFilterDisplayReviewed({
  predicate,
}: TransactionColumnFilterDisplayReviewedProps): JSX.Element {
  // Parse the predicate to extract the boolean value
  // Expected structure: P.Equals(P.Field("reviewed"), P.Literal(boolean))
  const serializable = predicate.asSerializable();

  if (serializable.name === P.OpName.Equals && serializable.args.length === 2) {
    const literalOp = serializable.args[1];
    if (literalOp.name === P.OpName.Literal) {
      const value = literalOp.args[0];
      if (typeof value === "boolean") {
        return <span>{value ? "Reviewed" : "Not reviewed"}</span>;
      }
    }
  }

  // Fallback if predicate structure is unexpected
  return <span>Reviewed filter</span>;
}
